import { userForgetPasswordSuccess, userForgetPasswordError, userForgetPassword_Start_Loading } from "./reducer"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import {
  postFakeForgetPwd,
  postJwtForgetPwd,
  reset_password_email_sent,
  reset_password_email_verification,
  update_password_data,
} from "../../../helpers/fakebackend_helper";
import { reset_email_password } from "../../../helpers/url_helper";
import { open_success_modal } from "../../Success_Modal/reducer";
import { open_error_modal } from "../../Error_Modal/reducer";

const fireBaseBackend = getFirebaseBackend();

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
      let response;
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {

          response = fireBaseBackend.forgetPassword(
              user.email
          )

      } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
          response = postJwtForgetPwd(
              user.email
          )
      } else {
          response = postFakeForgetPwd(
              user.email
          )
      }

      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(
              "Reset link are sended to your mailbox, check there first"
          ))
      }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}




export const userForgetPassword_Email_Verify = (data, navigate) => async (dispatch) => {
    try {
         
        // start loading 
        dispatch(userForgetPassword_Start_Loading())

        let request_ = reset_password_email_verification(data)

        await request_

        dispatch(userForgetPasswordSuccess(data))
        dispatch(open_success_modal('Password Update Successfully'))
        navigate('/login')
        

    } catch (forgetError) {
        print(forgetError)
        // dispatch(userForgetPasswordError(forgetError))
    }
  }



  export const userForgetPassword_Email_Send = (data) => async (dispatch) => {
    try {
         
        // start loading 
        dispatch(userForgetPassword_Start_Loading())

        let request_ = reset_password_email_sent(data)

        await request_

        dispatch(userForgetPasswordSuccess())
        dispatch(open_success_modal('Email Sent Successfully'))
        // navigate('/login')
        

    } catch (forgetError) {
        //   print(forgetError)
        dispatch(userForgetPasswordError(forgetError))
    }
  }


  export const update_password_details = (data) => async (dispatch) => {
    try {
         
        // start loading 
        dispatch(userForgetPassword_Start_Loading())

        let request_ = update_password_data({
            key:"password",
            value:data
        })

        await request_

        dispatch(userForgetPasswordSuccess())
        dispatch(open_success_modal('Password Updated Successfully'))
        // navigate('/login')
        

    } catch (forgetError) {
        dispatch(open_error_modal('The password reset link is expired. Please request again.'))  
        dispatch(userForgetPasswordError(forgetError))
    }
  }